export const SERVICE_HTTP_ADDRESS = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://hml.api.trucoxp.com";
export const MILISECONDS_TO_FETCH_GAME_STATE = 2000;